export default __webpack_public_path__ + "9f721ea9c1ed2bcab119ee39241c7a75.png";